/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Log_TitleInputs */

const cs_gdpr_log_title = /** @type {(inputs: Gdpr_Log_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kdo pracoval s osobními údaji`)
};

const en_gdpr_log_title = /** @type {(inputs: Gdpr_Log_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who worked with personal data`)
};

/**
* | output |
* | --- |
* | "Who worked with personal data" |
*
* @param {Gdpr_Log_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_log_title = /** @type {((inputs?: Gdpr_Log_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Log_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_log_title(inputs)
	return cs_gdpr_log_title(inputs)
});